
// import { WagerFacade } from '@amwager/wager/data-access';
/* eslint-disable @typescript-eslint/no-explicit-any */
// Angular
import { Inject, Injectable, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

// Third party
import Pusher from 'pusher-js/with-encryption';
import * as _ from 'lodash';

// Local Library
import {
  IBalancePusher,
  IGetEventsDetailsResponse,
  IPusher,
  IPusherDataTTL,
  IPusherDataURC,
  TError,
  TO_DECRYPT
} from '@amwager/util-ts';

// Local file
import { PUSHER } from '../tokens';
import { CommonFacade } from '../+state';
import { SessionService } from './session.service';
// import { AccountFacade } from '@amwager/account/data-access';



@Injectable()
export class PusherService implements OnDestroy {

  private selectedEventTrack!: IGetEventsDetailsResponse;

  private pusher: any;
  private pusherKeyDecrypted: Promise<string>;
  private updateGeneralChannel: any;
  private updateOddsChannel: any;
  private updateCustomerChannel: any;

  private runId!: string;

  // private selectedEventTrack?: IGetEventsDetailsResponse;
  private selectedRace!: any;

  private subscription?: string;

  constructor(
    @Inject(PUSHER) private readonly pusherEnv: any,
    private readonly commonFacade: CommonFacade,
    // private readonly wagerFacade: WagerFacade,
    private readonly sessionService: SessionService,
    // private readonly accountFacade: AccountFacade
  ) {

    this.pusherKeyDecrypted = TO_DECRYPT(this.pusherEnv?.key);

    // TODO: get the selectedEventTrack
    // this.wagerFacade.getSelectedEventTrack$()
    //   .subscribe((selectedEventTrack?: IGetEventsDetailsResponse) => {
    //     this.selectedEventTrack = selectedEventTrack;


    //     if (!this.selectedEventTrack) return;

        // TODO: put this code before selecting the new selected event
        // if (this.updateOddsChannel) { // clean first
        //   try {
        //     this.pusher.unsubscribe('odds' + this.selectedEventTrack?.ToteResponse.EventDetail.EventId);
        //   }
        //   catch (error) {
        //     this.commonFacade.log(`Pusher unsubscribe odds: ${error}`);
        //   }

        //   this.updateOddsChannel = undefined;
        // }



    //     // TODO
    //     return;
    //     // odds
    //     this.updateOddsChannel = this.pusher.subscribe('odds' + this.selectedEventTrack?.ToteResponse.EventDetail.EventId);
    //     this.updateOddsChannel.bind('ALL', (data: any) => {
    //       console.log('PusherService:updateOddsChannel:', data);
    //       this.processMessage(data);
    //     });
    //   });
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    this.disconnect();
  }

  async connect(): Promise<void> {
    this.disconnect();
    this.pusher = undefined;

    this.commonFacade.log('Pusher: connecting...');

    try {
      this.pusher = new Pusher(
        await this.pusherKeyDecrypted,
        {
          cluster: this.pusherEnv?.cluster,
        }
      );
      this.commonFacade.log('Pusher: connected');

      this.pusher?.connection.bind("error", (error: TError) => {
        console.error(`Pusher: ${error}`);
        this.commonFacade.log(`ERROR Pusher: ${error}`);
      });

      this.reconnections();
      this.subscriptions();
    }
    catch (error) {
      console.error(`Pusher: not connecting: ${error}`);
      this.commonFacade.log(`ERROR Pusher: ${error}`);

      this.pusher = undefined;
    }
  }

  disconnect(): void {
    this.commonFacade.log('Pusher: disconnect');
    this.pusher?.disconnect();
  }

  private reconnections(): void {
    // unavailable
    this.pusher.connection.bind('unavailable', () => {
      this.commonFacade.log('Pusher is unavailable. Reconnecting...');
      this.connect();
    });

    // disconneced
    this.pusher.connection.bind('disconneced', () => {
      this.commonFacade.log('Pusher is disconneced. Reconnecting...');
      this.connect();
    });
  }

  private subscriptions(): void {
    const text = 'Pusher: setting subscriptions...';
    this.commonFacade.log(text);
    // console.log(text);

    // general
    if (this.updateGeneralChannel) { // clean first
      try {
        this.pusher.unsubscribe("global");
      }
      catch (error) {
        this.commonFacade.log(`Pusher unsubscribe global: ${error}`);
      }

      this.updateGeneralChannel = undefined;
    }

    this.updateGeneralChannel = this.pusher.subscribe("global");
    this.updateGeneralChannel.bind('ALL', (data: any) => {
      this.processMessage(data);
    });

    // // odds
    // this.updateOddsChannel = this.pusher.subscribe('odds' + this.selectedEventTrack?.ToteResponse.EventDetail.EventId);
    // this.updateOddsChannel.bind('ALL', (data: any) => {
    //   console.log('PusherService:updateOddsChannel:', data);
    //   this.processMessage(data);
    // });

    // customer
    this.unSubscribeCustomer();
    this.subscribeCustomer();
  }

  unSubscribeCustomer(): void {
    if (!this.subscription) return;

    const text = 'Pusher: Unsubscribing customer...';
    this.commonFacade.log(text);
    // console.log(text);

    try {
      this.pusher.unsubscribe('sub' + this.subscription);

      this.updateCustomerChannel = undefined;
      this.subscription = undefined;
    }
    catch (error) {
      this.commonFacade.log(`Pusher unsubscribe customer: ${error}`);
    }

  }

  subscribeCustomer(): void {
    if (!this.sessionService.getSubscription()) return;

    const text = 'Pusher: Subscribing customer...';
    this.commonFacade.log(text);
    // console.log(text);

    this.subscription = this.sessionService.getSubscription();

    this.updateCustomerChannel = this.pusher.subscribe('sub' + this.subscription);
    this.updateCustomerChannel.bind('ALL', (data: any) => {
      // console.log('PusherService:updateCustomerChannel:', data);
      this.processMessage(data);
    });
  }

  private processMessage(message: any): void {
    if (!message) return;

    let msgJSON: any;
    let msgTemp = '';

    msgTemp = message.replace("\u0001", "");

    const firstMssgeIndex = msgTemp.indexOf("{");
    const lastMssgeIndex = msgTemp.lastIndexOf("}") + 1;

    msgTemp = msgTemp.substring(firstMssgeIndex, lastMssgeIndex);

    if (msgTemp.length > 1) {
      try {
        msgJSON = JSON.parse(msgTemp);
      }
      catch (error) {
        this.commonFacade.log(`Pusher: JSON format incorrect: ${msgTemp}`);
        return;
      }

      const command: string =  msgJSON.Command;

      this.commonFacade.setPusherData(command, msgJSON, 'PusherService:processMessage');

    }
  }



  commandController(command: string, data: IPusher, service: any): void {
    switch (command) {
        case "RB": this.RB(data); break;
        case "RCN": this.RCN(data, service?.wagerFacade); break;
        case "RCL": this.RCL(data, service?.wagerFacade); break;
        case "TD": this.TD(data); break;
        case "TE": this.TE(data); break;
        case "ES": this.ES(data); break;
        case "FI": this.FI(data, service?.wagerFacade); break;
        case "TI": this.TI(data); break;
        case "RO": this.RO(data, service?.wagerFacade); break;
        case "PO": this.PO(data, service?.wagerFacade); break;
        case "TS": this.TS(data); break;
        case "TC": this.TC(data); break;
        case "TO": this.TO(data); break;
        case "UC": this.UC(data); break;
        case "RUO": this.RUO(data); break;
        case "PM": this.PM(data, service?.wagerFacade); break;
        case "TTL": this.TTL(data); break;
        case "URC": this.URC(data, service?.wagerFacade); break;
        case "STI": this.STI(data, service?.accountFacade, service?.wagerFacade); break;
        case "STC": this.STC(data); break;
        case "SST": this.SST(data, service?.wagerFacade); break;
        case "STS": this.STS(data, service?.accountFacade, service?.wagerFacade); break;
        case "TIC": this.TIC(data, service?.accountFacade, service?.wagerFacade); break;
        case "STR": this.STR(data, service?.wagerFacade); break;
        case "FUS": this.FUS(data); break;
        case "FUC": this.FUC(data); break;
        case "TP": this.TP(data, service?.wagerFacade, service?.accountFacade, service?.myBets); break;
        case "BAL": this.BAL(data as unknown as IBalancePusher, service?.accountFacade); break;
        case "ROL": this.ROL(data); break;
        case "EXC": this.EXC(data); break;
        case "IDCHECK": this.IDCHECK(data); break;
        case "DOCCHECK": this.DOCCHECK(data); break;
        case "LGN": this.LGN(data); break;
        default: //do something
      }
  }


   /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race begin
  private RB(data: IPusher): void {
    // Empty from PRO

    const value = data?.Data;

    // console.log('RB:value', value)
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race cancelled
  private RCN(data: IPusher, wagerFacade?: object): void {
    // console.log('RCN:data', data);

    try {
      (wagerFacade as any).updateRaceCancelled(
        'PusherService:RCN',
        data
      );
    } catch (error) {
      console.error('Pusher: RCN: wagerFacade.updateRaceCancelled')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race close
  private RCL(data: IPusher, wagerFacade?: object): void {
    // console.log('RCL:data', data);

    try {
      (wagerFacade as any).updateRaceClosed(
        'PusherService:RCL',
        data
      );
    } catch (error) {
      console.error('Pusher: RCL: wagerFacade.updateRaceClosed')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race final
  private FI(data: IPusher, wagerFacade?: object): void {
    // console.log('FI:data', data);

    try {
      (wagerFacade as any).updateRaceFinal(
        'PusherService:FI',
        data
      );
    } catch (error) {
      console.error('Pusher: FI: wagerFacade.updateRaceFinal')
    }



    try {
      const statuses = {
        3: 'active',
        6: 'close'
      };

      _.map([3, 6], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:FI'
        );
      });
    } catch (error) {
      console.error('Pusher: FI: wagerFacade.getBetsAPI')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race open
  private RO(data: IPusher, wagerFacade?: object): void {
    // console.log('RO:data', data);

    try {
      (wagerFacade as any).updateRaceOpen(
        'PusherService:RO',
        data
      );
    } catch (error) {
      console.error('Pusher: RO: wagerFacade.updateRaceOpen')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race post
  private PO(data: IPusher, wagerFacade?: object): void {
    // console.log('PO:data', data);

    try {
      (wagerFacade as any).updateRacePost(
        'PusherService:PO',
        data
      );
    } catch (error) {
      console.error('Pusher: PO: wagerFacade.updateRacePost')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race uncancelled
  private UC(data: any): void {
    // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race un-official
  private RUO(data: any): void {
    // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // race update
  private URC(data: IPusher, wagerFacade?: object): void {
    let value: IPusherDataURC | null;

    // console.log('URC:data', data);

    // try {
    //   value = JSON.parse(data?.Data);
    //   console.log('URC:value', value)
    // }
    // catch(e) {
    //   value = nullupdateRaceFinal
    // }

    // console.log('URC:value2', value)

    // console.log('URC:value', value)

    if (data?.Data) {
      try {
        (wagerFacade as any).updateRace(
          'PusherService:URC',
          data?.Data
        );
      }
      catch (error) {
        console.error('Pusher: URC: wagerFacade.updateRace')
      }
    }
    else {
      try {
        (wagerFacade as any).getRace(
          'PusherService:URC',
          data?.RaceId,
          data?.RunId,
          data?.EventId
        );
      }
      catch (error) {
        console.error('Pusher: URC: wagerFacade.getRace')
      }
    }

  }


  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // tote deactive
  private TD(data: any): void {
    // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // tote end
  private TE(data: any): void {
    // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // tote initialize
  private TI(data: any): void {
    // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // tote stop
  private TS(data: any): void {
  // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // tote close
  private TC(data: any): void {
  // Empty from PRO
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // tote open
  private TO(data: any): void {
    window.location.reload();
  }


  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // event status update
  private ES(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // pool matrix update`
  private PM(data: any, wagerFacade?: object): void {
    // console.log('PusherService:PM:', data);

    if (
      !(data?.RunId === this.selectedRace?.runId
        && data?.EventId === this.selectedRace?.eventId
        && data?.RaceId === this.selectedRace?.RaceId)
    ) return;

    try {
      if (data?.Data) {
        // console.log('PusherService:PM:updateRaceMatrix:', data);
        (wagerFacade as any).updateRaceMatrix(
          'PusherService:PM',
          data?.Data
        );
      }
      else {
        // console.log('PusherService:PM:getPoolMatrix:', data);
        (wagerFacade as any).getPoolMatrix(
          'PusherService:PM',
          {
            raceId: data?.RaceId,
            eventId: data?.EventId,
            runId: data?.RunId,
            poolId: data?.PoolId
          },
          true
        );
      }

      // get pools totals
      (wagerFacade as any).getPoolsTotals(
        'PusherService:PM',
        {
          raceId: data?.RaceId,
          eventId: data?.EventId,
          runId: data?.RunId,
        },
        true
      );


      if (['WIN', 'TRU'].includes(data?.PoolId)) {
        // get race odd matrixes with WIN pool
        (wagerFacade as any).getRaceAllOddsMatrixes(
          'PusherService:PM',
          data?.PoolId,
          {
            raceId: data?.RaceId,
            eventId: data?.EventId,
            runId: data?.RunId,
            poolId: data?.PoolId
          },
          true
        );
      }

    } catch (error) {
      console.error('Pusher: PM: wagerFacade: matrix')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // Joem: Murag  para na sya dd2 sa pooltotal naa kilid sa matrix tabs.
  private TTL(data: IPusher): void {
    // let value: IPusherDataTTL | null;

    // try {
    //   value = JSON.parse(data?.Data);
    // }
    // catch(e) {
    //   value = null
    // }

    // console.log('TTL:value', value)
  }


  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // single ticket issue
  private STI(data: any, accountFacade?: object, wagerFacade?: object): void {
    // console.log('STI:', {data})

    if (data?.Balance) {
      try {
        (accountFacade as any).setBalance(
          data?.Balance,
          'PusherService:STI',
        );
      } catch (error) {
        console.error('Pusher: STI: accountFacade.setBalance')
      }
    }
    else {
      try {
        (accountFacade as any).getBalance(
          'PusherService:STI',
        );
      } catch (error) {
        console.error('Pusher: STI: accountFacade.getBalance')
      }
    }


    try {
      const statuses = {
        3: 'active',
      };

      _.map([3], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:STI'
        );
      });
    } catch (error) {
      console.error('Pusher: STI: wagerFacade.getBetsAPI')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // ticket cancel
  private TIC(data: any, accountFacade?: object, wagerFacade?: object): void {
    try {
      (accountFacade as any).getBalance(
        'PusherService:TIC',
      );
    } catch (error) {
      console.error('Pusher: TIC: accountFacade.getBalance')
    }

    try {
      const statuses = {
        3: 'active',
      };

      _.map([3], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:TIC'
        );
      });
    } catch (error) {
      console.error('Pusher: TIC: wagerFacade.getBetsAPI')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // ticket payoff
  private TP(data: IPusher,  wagerFacade?: object, accountFacade?: object, myBets?: any): void {
    // const value = data?.Data;

    // console.log('TP:data', data)
    // console.log('TP:data', [...myBets?.close||[], ...myBets?.active||[]])

    let isExist = false;

    _.map([...myBets?.close||[], ...myBets?.active||[]], (ticket) => {
      // console.log('TP:data', ticket)
      if (ticket?.EventId === data?.EventId) isExist = true;
    });

    if (!isExist) return;

    try {
      const statuses = {
        6: 'close',
        3: 'active',
      };

      _.map([6, 3], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:TP'
        );
      });
    } catch (error) {
      console.error('Pusher: TP: wagerFacade.getBetsAPI')
    }

    try {
      (accountFacade as any).getBalance(
        'PusherService:TP',
      );
    } catch (error) {
      console.error('Pusher: TP: accountFacade.getBalance')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // stack ticket condition met
  private STC(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // stack single ticket
  private SST(data: any, wagerFacade?: object): void {
    try {
      const statuses = {
        1: 'saved',
      };

      _.map([1], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:SST'
        );
      });
    } catch (error) {
      console.error('Pusher: SST: wagerFacade.getBetsAPI')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // stack ticket submit
  private STS(data: any, accountFacade?: object, wagerFacade?: object): void {
    if (data?.Balance) {
      try {
        (accountFacade as any).setBalance(
          data?.Balance,
          'PusherService:STS',
        );
      } catch (error) {
        console.error('Pusher: STS: accountFacade.setBalance')
      }
    }
    else {
      try {
        (accountFacade as any).getBalance(
          'PusherService:STS',
        );
      } catch (error) {
        console.error('Pusher: STS: accountFacade.getBalance')
      }
    }


    try {
      const statuses = {
        1: 'saved',
        3: 'active',
      };

      _.map([1, 3], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:STS'
        );
      });
    } catch (error) {
      console.error('Pusher: STS: wagerFacade.getBetsAPI')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // stack ticket remove
  private STR(data: any, wagerFacade?: object): void {
    // console.log('pusher:STR')
    try {
      const statuses = {
        1: 'saved',
      };

      _.map([1], (status) => {
        (wagerFacade as any).getBetsAPI(
          {
            runId: this.runId,
            ticketStatus: status,
            offset: 0,
            next: 500
          },
          (statuses as any)[status],
          'PusherService:STR'
        );
      });
    } catch (error) {
      console.error('Pusher: STR: wagerFacade.getBetsAPI')
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // file upload start
  private FUS(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // file upload complete
  private FUC(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // balance update
  private BAL(data: IBalancePusher, accountFacade?: object): void {
    try {
      (accountFacade as any).setBalance(
        data?.Balance,
        'PusherService:BAL',
      );
    } catch (error) {
      console.error('Pusher: BAL: accountFacade.setBalance')
    }

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  private ROL(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  private IDCHECK(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  private DOCCHECK(data: any): void {

  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // login
  private LGN(data: any): void {
    if (data && data.Data) {
      let response: any;


      // try {
      //   response = JSON.parse(data?.Data);
      // }
      // catch(e) {
      //   response = null
      // }

      // this.setRoleId(response.RoleId);

      // TODO: ask Ralph on what data are thrown in the pusher
      // and ask on types of Data
      // and ask Ralph on the description on each properties
    }
  }

  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/no-empty-function */
  // exchanges update
  private EXC(data: any): void {
    // Empty from PRO
  }





  setSelectedEventTrack(selectedEventTrack?: IGetEventsDetailsResponse): void {
    if (!selectedEventTrack) return;

    // console.log('PusherService:selectedEventTrack:', selectedEventTrack);

    this.runId = selectedEventTrack?.ToteResponse?.RunId


    // TODO: put this code before selecting the new selected event
    if (this.updateOddsChannel) { // clean first
      try {
        this.pusher.unsubscribe('odds' + this.selectedEventTrack?.ToteResponse.EventDetail.EventId);
      }
      catch (error) {
        this.commonFacade.log(`Pusher unsubscribe odds: ${error}`);
      }

      this.updateOddsChannel = undefined;
    }

    this.selectedEventTrack = selectedEventTrack;

    // odds
    this.updateOddsChannel = this.pusher.subscribe('odds' + this.selectedEventTrack?.ToteResponse.EventDetail.EventId);
    this.updateOddsChannel.bind('ALL', (data: any) => {
      // console.log('PusherService:updateOddsChannel:', data);
      this.processMessage(data);
    });
  }

  setSelectedRace(selectedRace?: any): void {
    if (!selectedRace) return;

    // console.log('PusherService:selectedRace:', selectedRace);

    this.selectedRace = selectedRace;
  }

}
